<template>
  <div class="wallet-card">
    <div class="user-section">
      <div class="avatar-wrapper">
        <!-- 用户头像 -->
        <img
          :src="userInfo.avatar ? userInfo.avatar : avatarImg"
          :alt="$t('account.avatar')"
          class="avatar"
        />
        <!-- 申请谈判人 -->
        <button
          v-if="showApplyBroker"
          class="apply-broker-badge"
          type="button"
          @click.stop="$emit('apply-broker')"
        >
          {{ $t("account.applyBroker") }}
        </button>
      </div>
      <div class="user-info">
        <div class="user-name">
          {{ userInfo.authnName || userInfo.nick_name || userInfo.mobile }}
        </div>
        <div class="user-type">
          <i :class="`el-icon-${userInfo.userTypeIcon}`"></i>
          <span>{{ userInfo.userType }}</span>
          <!-- 好评等级1 -->
          <span
            v-if="userInfo.businessType === 10 || userInfo.businessType === 20"
            class="goodlevel"
          >
            {{ userInfo.goodlevel ?? $t("account.defaultReviewLevel") }}
          </span>
        </div>
      </div>
    </div>

    <div class="assets-overview">
      <div class="asset-header">
        <div class="asset-icon">
          <i class="el-icon-wallet"></i>
        </div>
        <!-- 资产概览 -->
        <span class="asset-title">{{ $t("account.assetsOverview") }}</span>
        <div class="asset-arrow" @click="handleClick">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <div class="asset-grid">
        <div class="asset-item main">
          <!-- 账户余额 -->
          <span class="asset-label">{{ $t("account.balance") }}</span>
          <span class="asset-value">
            <span class="currency">¥</span>
            {{ $formatPrice(balance.totalBalance || 0) }}
          </span>
        </div>

        <div class="asset-item">
          <!-- 可提现 -->
          <span class="asset-label">{{ $t("account.withdrawable") }}</span>
          <span class="asset-value">{{
            $formatPrice(balance.withdrawableBalance || 0)
          }}</span>
        </div>

        <div class="asset-item">
          <!-- 冻结中 -->
          <span class="asset-label">{{ $t("account.frozen") }}</span>
          <span class="asset-value">{{ $formatPrice(balance.frozenBalance || 0) }}</span>
        </div>

        <div class="asset-item points-item" @click.stop="$emit('points-click')">
          <!-- 积分 -->
          <span class="asset-label">{{ $t("account.points") }}</span>
          <span class="asset-value">{{ balance.jf || 0 }}</span>
        </div>

        <div class="asset-item">
          <!-- 金币 -->
          <span class="asset-label">{{ $t("account.coins") }}</span>
          <span class="asset-value">{{ balance.jb || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WalletCard",
  props: {
    balance: {
      type: Object,
      default: () => ({
        totalBalance: 0,
        frozenBalance: 0,
        withdrawableBalance: 0,
        jf: 0,
        jb: 0,
      }),
    },
    userInfo: {
      type: Object,
    },
    showApplyBroker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      avatarImg: require("@/assets/default-avatar.png"),
    };
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less" scoped>
@brand-color: #4286f5;
@text-primary: #303133;
@text-secondary: #c0c4cc;
@border-color: #f5f5f5;

.wallet-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .user-section {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid @border-color;
    margin-bottom: 16px;

    .avatar-wrapper {
      position: relative;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 14px;
      flex-shrink: 0;

      .avatar {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }

      .apply-broker-badge {
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translateX(-50%);
        border: none;
        border-radius: 12px;
        background: @brand-color;
        color: #fff;
        cursor: pointer;
        font-size: 11px;
        line-height: 18px;
        padding: 0 8px;
        white-space: nowrap;
      }
    }

    .user-info {
      flex: 1;
      min-width: 0;

      .user-name {
        font-size: 16px;
        font-weight: 600;
        color: @text-primary;
        margin-bottom: 4px;
      }

      .user-type {
        font-size: 12px;
        color: @text-secondary;
        display: flex;
        align-items: center;
        gap: 6px;

        i {
          font-size: 12px;
        }

        .goodlevel {
          color: #ff9800;
          font-size: 11px;
        }
      }
    }
  }

  .assets-overview {
    .asset-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .asset-icon {
        width: 28px;
        height: 28px;
        background: rgba(66, 134, 245, 0.08);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;

        i {
          font-size: 14px;
          color: @brand-color;
        }
      }

      .asset-title {
        font-size: 14px;
        font-weight: 500;
        color: @text-primary;
      }

      .asset-arrow {
        margin-left: auto;
        cursor: pointer;

        i {
          font-size: 14px;
          color: @text-secondary;
        }
      }
    }

    .asset-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 0;

      .asset-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 12px 0;
        border-right: 1px solid @border-color;

        &:last-child {
          border-right: none;
        }

        &.main {
          .asset-value {
            color: @brand-color;
            font-weight: 600;

            .currency {
              font-size: 14px;
              margin-right: 2px;
            }
          }
        }

        .asset-label {
          font-size: 12px;
          color: @text-secondary;
          margin-bottom: 6px;
        }

        .asset-value {
          font-size: 18px;
          font-weight: 500;
          color: @text-primary;
        }
      }
    }
  }
}

.points-item {
  cursor: pointer;
}

.points-item:hover {
  background: #f3f8ff;
}
</style>
